'use strict';

import type { IndPolicyGroup } from '../../Entities/Ind/IndPolicyGroup';
import { EntityCollection } from '../EntityCollection';

export class IndPolicyGroupCollection extends EntityCollection<IndPolicyGroup> {}
